export default __webpack_public_path__ + "static/media/Weather.9a3c43ed.PNG";